
// --- Firmhouse Variant Sync ---
;(function() {
    function selectVariantById(variantId) {
        const productContainer = document.querySelector('[data-section-type="product"], [data-section-type^="product-template"]'); 
        if (!productContainer) return;

        const productJsonElement = productContainer.querySelector('[data-product-json]');
        if (!productJsonElement) return;
        
        const product = JSON.parse(productJsonElement.textContent);
        const variant = product.variants.find(v => v.id == variantId);
        if (!variant) return;

        let changed = false;
        variant.options.forEach((optionValue, index) => {
            if (optionValue === null) return;
            const optionKey = `option${index + 1}`;
            const selectorsForOption = productContainer.querySelectorAll(`[data-product-option-selector][data-index="${optionKey}"]`);
            if (selectorsForOption.length === 0) return;

            if (selectorsForOption[0].tagName === 'SELECT') {
                if (selectorsForOption[0].value !== optionValue) {
                    selectorsForOption[0].value = optionValue;
                    changed = true;
                }
            } else if (selectorsForOption[0].type === 'radio') {
                selectorsForOption.forEach(radio => {
                    if (radio.value === optionValue && !radio.checked) {
                        radio.checked = true;
                        changed = true;
                    }
                });
            }
        });

        if (changed) {
            const firstSelector = productContainer.querySelector(`[data-product-option-selector]`);
            if (firstSelector) {
                firstSelector.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    function updateFirmhouseActiveOption(variantId) {
      document.querySelectorAll('.firmhouse_selling_plan_app_container').forEach(firmhouseBlock => {
          const options = firmhouseBlock.querySelectorAll('.custom-select__option');
          if (!options.length) return;

          options.forEach(option => option.classList.remove('active'));

          const activeOption = firmhouseBlock.querySelector(`.custom-select__option[data-value="${variantId}"]`);
          if (activeOption) {
              activeOption.classList.add('active');
          }
      });
    }

    function hideDefaultVariantPicker(container) {
        const firmhouseBlock = container.querySelector('.firmhouse_selling_plan_app_container');
        if (firmhouseBlock) {
            const variantPicker = container.querySelector('.dbtfy-variant-picker');
            if (variantPicker) {
                variantPicker.style.display = 'none';
            }
        }
    }

    function getProductInfo(sourceNode) {
        return sourceNode?.closest('product-info')
            || document.querySelector('product-info[id^="MainProduct"]')
            || document.querySelector('product-info');
    }

    function syncFirmhouseVariant(variantId, sourceNode) {
        if (!variantId || !/^\d+$/.test(String(variantId))) return;

        const productInfo = getProductInfo(sourceNode);
        if (!productInfo?.dataset.url) return;

        const variantIdString = String(variantId);
        const productUrl = productInfo.dataset.url;
        const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;

        if (productInfo.dataset.updateUrl !== 'false') {
            const nextUrl = `${productUrl}?variant=${variantIdString}`;
            const currentUrl = `${window.location.pathname}${window.location.search}`;
            if (currentUrl !== nextUrl) {
                window.history.replaceState({}, '', nextUrl);
            }

            productInfo.querySelector('share-button')?.updateUrl(
                `${window.shopUrl}${productUrl}?variant=${variantIdString}`
            );
        }

        productInfo.querySelectorAll(
            `#product-form-${productInfo.dataset.section}, #product-form-installment-${productInfo.dataset.section}`
        ).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input || input.value === variantIdString) return;
            input.value = variantIdString;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (productInfo.dataset.firmhouseSyncedVariant === variantIdString) return;
        productInfo.dataset.firmhouseSyncedVariant = variantIdString;

        productInfo._firmhouseSyncAbort?.abort();
        const abortController = new AbortController();
        productInfo._firmhouseSyncAbort = abortController;

        fetch(`${productUrl}?variant=${variantIdString}&section_id=${sectionId}`, {
            signal: abortController.signal
        })
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                const updateSourceFromDestination = (id, shouldHide = () => false) => {
                    const source = html.getElementById(`${id}-${sectionId}`);
                    const destination = productInfo.querySelector(`#${id}-${productInfo.dataset.section}`);
                    if (!source || !destination) return;
                    destination.innerHTML = source.innerHTML;
                    destination.classList.toggle('hidden', shouldHide(source));
                };

                updateSourceFromDestination('price');
                updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
                updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
                updateSourceFromDestination('Volume');
                updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

                const submitButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
                if (submitButton) {
                    productInfo.querySelector('product-form')?.toggleSubmitButton(
                        submitButton.hasAttribute('disabled'),
                        window.variantStrings?.soldOut
                    );
                }
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            });
    }

    function selectFirmhouseOptionFromUrl() {
        const variantId = new URLSearchParams(window.location.search).get('variant');
        if (!variantId || !/^\d+$/.test(variantId)) return false;

        const containers = document.querySelectorAll('.firmhouse_selling_plan_app_container');
        if (!containers.length) return false;

        let waitingForWidget = false;

        containers.forEach((container) => {
            if (container.dataset.initialized !== 'true') {
                waitingForWidget = true;
                return;
            }
            if (container.dataset.urlVariantApplied === variantId) return;

            const matches = container.querySelectorAll(`.custom-select__option[data-value="${variantId}"]`);
            if (!matches.length) {
                waitingForWidget = true;
                return;
            }

            const checkedRadio = container.querySelector('input[type="radio"]:checked');
            const option = (checkedRadio && [...matches].find((item) => item.closest('label')?.contains(checkedRadio))) || matches[0];
            const hiddenSelect = option.closest('.custom-select-wrapper')?.querySelector('.sales_option_widget__variant_select');
            const alreadySelected = hiddenSelect?.value === variantId;

            container.dataset.urlVariantApplied = variantId;
            updateFirmhouseActiveOption(variantId);

            if (!alreadySelected) {
                option.click();
            }

            const input = getProductInfo(container)?.querySelector('input.product-variant-id[name="id"]');
            if (input && input.value !== variantId) {
                input.value = variantId;
            }
        });

        return !waitingForWidget;
    }

    function initFirmhouseIntegration() {
        // Event delegation for radio button changes
        document.body.addEventListener('change', function(event) {
            const target = event.target;
            if (target.matches('.firmhouse_selling_plan_app_container input[type="radio"]')) {
                const variantId = target.dataset.variantId
                    || target.closest('label')?.querySelector('.sales_option_widget__variant_select')?.value;
                if (variantId) {
                    selectVariantById(variantId);
                    updateFirmhouseActiveOption(variantId);
                    if (event.isTrusted) {
                        syncFirmhouseVariant(variantId, target);
                    }
                }
            }
        });

        // Event delegation for custom div option clicks
        document.body.addEventListener('click', function(event) {
            const customOption = event.target.closest('.custom-select__option');
            if (customOption && customOption.closest('.firmhouse_selling_plan_app_container')) {
                const variantId = customOption.dataset.value;
                if (variantId) {
                    const oneTimePurchaseBlock = customOption.closest('.sales_option_widget__one_time_purchase_option');
                    if (oneTimePurchaseBlock) {
                        const oneTimeRadio = oneTimePurchaseBlock.querySelector('input[data-radio-type="one_time"]');
                        if (oneTimeRadio && !oneTimeRadio.checked) {
                            oneTimeRadio.checked = true;
                        }
                        const hiddenSelect = oneTimePurchaseBlock.querySelector('.sales_option_widget__variant_select');
                        if (hiddenSelect && hiddenSelect.value !== variantId) {
                            hiddenSelect.value = variantId;
                        }
                    }
                    selectVariantById(variantId);
                    updateFirmhouseActiveOption(variantId);
                    if (event.isTrusted) {
                        syncFirmhouseVariant(variantId, customOption);
                    }
                }
            }
        });
        
        // Listen for the theme's variantChange event to sync the active state to the Firmhouse UI
        document.body.addEventListener('variantChange', function(event) {
            if (event.detail && event.detail.variant) {
                updateFirmhouseActiveOption(event.detail.variant.id);
            }
        });

        // Initial check on all sections
        document.querySelectorAll('[data-section-id]').forEach(section => {
            hideDefaultVariantPicker(section);
        });

        // Set initial active state based on current variant
        const productContainer = document.querySelector('[data-section-type="product"], [data-section-type^="product-template"]');
        if (productContainer) {
            const masterSelect = productContainer.querySelector('[data-product-master-select]');
            if (masterSelect && masterSelect.value) {
                updateFirmhouseActiveOption(masterSelect.value);
            }
        }

        watchFirmhouseUrlVariant();
    }    

    function watchFirmhouseUrlVariant() {
        const variantId = new URLSearchParams(window.location.search).get('variant');
        if (!variantId) return;

        const apply = () => selectFirmhouseOptionFromUrl();
        if (apply()) return;

        const observer = new MutationObserver(() => {
            if (apply()) observer.disconnect();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-initialized']
        });
        window.setTimeout(() => observer.disconnect(), 8000);
    }

    // Run on initial page load
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', initFirmhouseIntegration);
    } else {
        initFirmhouseIntegration();
    }
    
    // Also run on section load for theme editor compatibility
    document.addEventListener('shopify:section:load', function(event) {
        const firmhouseContainer = event.target.querySelector('.firmhouse_selling_plan_app_container');
        if (firmhouseContainer) {
            hideDefaultVariantPicker(event.target);
            const masterSelect = event.target.querySelector('[data-product-master-select]');
            if (masterSelect && masterSelect.value) {
                updateFirmhouseActiveOption(masterSelect.value);
            }
            watchFirmhouseUrlVariant();
        }
    });
})();

// document.addEventListener('DOMContentLoaded', function () {
//     const stars = document.querySelector('.product__info-wrapper .star-rating-stars');
//     const reviewSection = document.querySelector('[id*="junip_junip_product_review_REwyyN"]');

//     if (stars && reviewSection) {
//         stars.addEventListener('click', function (e) {
//         e.preventDefault();
//         reviewSection.scrollIntoView({
//             behavior: 'smooth',
//             block: 'start'
//         });
//         });
//     }
// });

document.addEventListener('DOMContentLoaded', function () {

  const stars = document.querySelectorAll('.product__info-wrapper .star-rating-stars, .grid__item.product__media-wrapper .mobile_title_and_reviews .star-rating-stars');
  const reviewSection = document.querySelector('[id*="junip_junip_product_review"]');

  if (!stars.length) return;

  stars.forEach(function(star){

    let ratingText = star.getAttribute('aria-label') || star.textContent;
    let ratingValue = parseFloat(ratingText);

    if (!ratingValue || ratingValue === 0) {
      star.style.display = 'none';
      return;
    }

    if (reviewSection) {
      star.addEventListener('click', function (e) {
        e.preventDefault();
        reviewSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }

  });

});



function matchHeadingHeight() {
  const elements = document.querySelectorAll(
    ".predictive-search__item-content .predictive-search__item-heading"
  );

  if (!elements.length) return;

  // Reset height
  elements.forEach(el => el.style.height = "auto");

  let rows = {};

  elements.forEach(el => {
    const top = Math.round(el.getBoundingClientRect().top);

    if (!rows[top]) rows[top] = [];
    rows[top].push(el);
  });

  Object.values(rows).forEach(row => {
    let maxHeight = 0;

    row.forEach(el => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    row.forEach(el => {
      el.style.height = maxHeight + "px";
    });
  });
}

/* Resize with debounce */
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    matchHeadingHeight();
  }, 250);
});

/* Observe predictive search container */
(function () {
  const predictiveObserver = new MutationObserver(() => {
    setTimeout(matchHeadingHeight, 100);
  });

  predictiveObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


/* Run on load */
window.addEventListener("load", () => {
  setTimeout(matchHeadingHeight, 200);
});

// $(document).ready(function() {

//     $('.bggle--slider').slick({
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         arrows: false,
//         dots: true,
//         infinite: false,
//         loop:false,
//         responsive: [
//             {
//                 breakpoint: 767,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                 }
//             }
//         ]
//     });


//     var $slider = $('.bggle--slider-blog');

// $slider.on('init', function(event, slick) {
//     var slideCount = slick.slideCount;

//     if (slideCount === 3) {
//         $slider.addClass('enable_dots');
//     } else {
//         $slider.removeClass('enable_dots');
//     }
// });

// $slider.slick({
//     slidesToShow: 3,
//     slidesToScroll: 3,
//     arrows: false,
//     dots: true,
//     infinite: false,
//     loop: false,
//     responsive: [
//         {
//             breakpoint: 767,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//             }
//         }
//     ]
// });

// });


// document.addEventListener("DOMContentLoaded", function () {
//   const checkboxes = document.querySelectorAll('input[type="checkbox"]');
//   const progressBar = document.getElementById("progressBar");
//   const progressText = document.getElementById("progressText");
//   const resetBtn = document.querySelector(".reset-checklist");

//   function updateProgress() {
//     const total = checkboxes.length;
//     const checked = document.querySelectorAll('input[type="checkbox"]:checked').length;
//     const percent = (checked / total) * 100;

//     progressBar.style.width = percent + "%";
//     progressText.textContent = checked + " van de " + total + " items ingepakt";

//     localStorage.setItem("checklistProgress", JSON.stringify(
//       [...checkboxes].map(cb => cb.checked)
//     ));
//   }

//   function loadProgress() {
//     const saved = JSON.parse(localStorage.getItem("checklistProgress"));
//     if (saved) {
//       checkboxes.forEach((cb, i) => {
//         cb.checked = saved[i];
//       });
//     }
//     updateProgress();
//   }

//   checkboxes.forEach(cb => {
//     cb.addEventListener("change", updateProgress);
//   });

//   if (resetBtn) {
//     resetBtn.addEventListener("click", function () {
//       checkboxes.forEach(cb => cb.checked = false);
//       localStorage.removeItem("checklistProgress");
//       updateProgress();
//     });
//   }

//   loadProgress();
// });

document.addEventListener("DOMContentLoaded", function () {

  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  const progressBar = document.getElementById("progressBar");
  const progressText = document.getElementById("progressText");
  const resetBtn = document.querySelector(".reset-checklist");

  function updateProgress() {

    const total = checkboxes.length - 1; // extra checkbox ignore
    const checked = document.querySelectorAll('input[type="checkbox"]:checked').length;

    const percent = (checked / total) * 100;

    if (progressBar) progressBar.style.width = percent + "%";
    if (progressText) progressText.textContent = checked + " van de " + total + " items ingepakt";

    localStorage.setItem("checklistProgress", JSON.stringify(
      [...checkboxes].map(cb => cb.checked)
    ));
  }

  function loadProgress() {

    const saved = JSON.parse(localStorage.getItem("checklistProgress"));

    if (saved) {
      checkboxes.forEach((cb, i) => {
        cb.checked = saved[i];
      });
    }

    updateProgress();
  }

  checkboxes.forEach(cb => {
    cb.addEventListener("change", updateProgress);
  });

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {

      checkboxes.forEach(cb => {
        cb.checked = false;
      });

      localStorage.removeItem("checklistProgress");

      updateProgress();

    });
  }

  loadProgress();

});


// function equalCardHeadingHeight() {
//   const headings = document.querySelectorAll('.card__heading');
//   const perRow = 4; // row ma ketla product che

//   for (let i = 0; i < headings.length; i += perRow) {
//     let rowItems = Array.from(headings).slice(i, i + perRow);
//     let maxHeight = 0;

//     rowItems.forEach(el => {
//       el.style.height = 'auto';
//       if (el.offsetHeight > maxHeight) {
//         maxHeight = el.offsetHeight;
//       }
//     });

//     rowItems.forEach(el => {
//       el.style.height = maxHeight + 'px';
//     });
//   }
// }

// window.addEventListener('load', equalCardHeadingHeight);
// window.addEventListener('resize', equalCardHeadingHeight);


document.addEventListener('DOMContentLoaded', function () {

  const elements = [
    document.getElementById('Details-menu-drawer-container'),
    document.querySelector('.mobile-facets__disclosure')
  ];

  elements.forEach((el) => {
    if (!el) return;

    const observer = new MutationObserver(function () {
      if (el.classList.contains('menu-opening')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

});

